// const API_BASE_PATH = "http://subasta.local:8088/api/"; // Local XAMPP
// const API_BASE_PATH = "http://localhost:8081/api/"; // Local XAMPP
// const API_BASE_PATH = "http://auctionbitel.arabicatech.vn/api/"; // Server Test
const API_BASE_PATH = "https://subasta.bitel.com.pe/api/" // Server product
// const API_BASE_PATH = "/api/";
const API_ADMIN_PATH = `${API_BASE_PATH}front/`;

const event2024 = {
  eventCheckStatus: `${API_ADMIN_PATH}new-year/check-status`,
  eventGetStatistic: `${API_ADMIN_PATH}new-year/get-statistic`,
  eventGetRank: `${API_ADMIN_PATH}new-year/get-rank-new-year`,
  eventPairing: `${API_ADMIN_PATH}new-year/pairing`,
  eventNoelHistory: `${API_ADMIN_PATH}noel/history`,
  eventNoelStartOpen: `${API_ADMIN_PATH}noel/start-open`,
};

export const API_PATHS = {
  login: `${API_ADMIN_PATH}login/account`,
  logout: `${API_ADMIN_PATH}user/logout`,
  register: `${API_ADMIN_PATH}register/account`,
  verify: `${API_ADMIN_PATH}verify/account`,
  getOTP: `${API_ADMIN_PATH}otp/account`,
  requestOtpPackage: `${API_ADMIN_PATH}otp/request-otp-package`,
  verifyOtpPackage: `${API_ADMIN_PATH}otp/verify-otp-package`,
  getUser: `${API_ADMIN_PATH}user/current`,
  getBidHistory: `${API_ADMIN_PATH}user/bid-history`,
  getRemainTurn: `${API_ADMIN_PATH}user/remain-turn`,
  updatePassword: `${API_ADMIN_PATH}user/update-password`,
  updateInformation: `${API_ADMIN_PATH}user/update-information`,
  viewInfoWinner: `${API_ADMIN_PATH}user/view-info-winner`,
  getPackageList: `${API_ADMIN_PATH}user/list-package`,

  bidProduct: `${API_ADMIN_PATH}product/bid`,
  upNextProduct: `${API_ADMIN_PATH}product/up-next`,
  finishedProduct: `${API_ADMIN_PATH}product/finished`,
  resultsProduct: `${API_ADMIN_PATH}product/results`,
  viewPotentialWinner: `${API_ADMIN_PATH}product/view-potential-winner`,

  bid: `${API_ADMIN_PATH}bid`,
  bidHistory: `${API_ADMIN_PATH}bid/history`,
  bidHistoryAll: `${API_ADMIN_PATH}bid/history-all`,
  packs: `${API_ADMIN_PATH}bid/packs`,
  registerPack: `${API_ADMIN_PATH}bid/register`,

  upload: `${API_BASE_PATH}upload`,

  detectMsisdn: `${API_ADMIN_PATH}login-via-4g/account`,
  // event 2024
  ...event2024
};
